import { render } from "./ListHotels.vue?vue&type=template&id=35501b4b"
import script from "./ListHotels.vue?vue&type=script&lang=js"
export * from "./ListHotels.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__